<template>
  <div>
    <order-input />
  </div>
</template>

<script>
import OrderInput from './../../components/order/input/Input';

export default {
  name: "Orders.vue",
  components: {
    OrderInput
  },
};
</script>

<style scoped lang="scss">

</style>
